import url from 'url';
import qs from 'qs';

export function urlStringToComponents(urlString, removeTrailingSlash = false) {
  if (typeof urlString !== 'string') {
    return {};
  }

  const { protocol, host, pathname, query, search } = url.parse(
    urlString,
    true,
    true,
  );
  let pathnameToUse = pathname || '';

  if (removeTrailingSlash && pathnameToUse.endsWith('/')) {
    pathnameToUse = pathnameToUse.slice(0, -1);
  }

  const urlWithoutQueryParams =
    protocol && host
      ? `${protocol}//${host}${pathnameToUse}`
      : `${pathnameToUse}`;

  return {
    url: `${urlWithoutQueryParams}${search}`,
    urlWithoutQueryParams,
    queryParams: query,
    queryString: search,
    pathname: pathnameToUse,
  };
}

export function urlComponentsToString(urlString, queryParamsObj) {
  const queryString = qs.stringify(queryParamsObj);

  return queryString ? `${urlString}?${queryString}` : urlString;
}
